import { useMemo } from 'react'
import { skipToken } from '@reduxjs/toolkit/query'

import { useWindow } from '@krp/client-runtime'
import {
  FEEDBACK_SCOPES,
  StructureScreen,
  aqsiDevices,
  devicesRefreshRequested,
  makeSelectStructureVm,
  ridKey,
  type StructureActions,
} from '@krp/resource-aqsi-ui'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import type { RootState } from '../../app/types'

/** Binding окна «Структура AQSI» (rid из окна): снимок касс кабинета и его загрузка. */
export function AqsiStructureBinding() {
  const window = useWindow()
  const dispatch = useAppDispatch()
  const resourceId = window.params.rid ?? ''
  const args = useMemo(() => ({ resourceId }), [resourceId])
  const { refetch } = aqsiDevices.useQuerySubscription(resourceId === '' ? skipToken : args)

  const selectVm = useMemo(() => {
    const selectPackageVm = makeSelectStructureVm()
    const selectDevices = aqsiDevices.select(args)
    const feedbackKey = ridKey(resourceId, FEEDBACK_SCOPES.catalog)
    return (state: RootState) =>
      selectPackageVm({ devices: selectDevices(state), feedback: state.aqsi.feedback.byKey[feedbackKey] })
  }, [args, resourceId])
  const vm = useAppSelector(selectVm)
  const actions = useMemo<StructureActions>(
    () => ({
      refresh: () => {
        if (!vm.busy) dispatch(devicesRefreshRequested({ resourceId }))
      },
      retry: () => void refetch(),
    }),
    [dispatch, refetch, resourceId, vm.busy],
  )
  return <StructureScreen vm={vm} actions={actions} />
}
